/**
 * Ordenacao client-side pura para o modal SeletorUsinasEolicas (WINDX-021).
 *
 * Retorna um array novo (nao muta a entrada) — necessario para que o
 * `useMemo` no consumidor invalide referencia e o React detecte mudanca.
 *
 * Comparacao numerica direta para `potencia`; string `localeCompare` com
 * collator pt-BR para os demais (lida com acentos e maiusculas/minusculas).
 * Valores `null` vao sempre pro fim, independente da direcao — convencao
 * comum em tabelas de UI ("sem dado" nao deve interferir na ordem visual).
 */
import {
  ColunaOrdenavelUsina,
  DirecaoOrdenacao,
  OrdenacaoUsinas,
  UsinaEolicaDenormalizada,
} from 'helper/windx';

function compararStrings(
  a: string | null,
  b: string | null,
  direcao: DirecaoOrdenacao,
): number {
  // null/undefined sempre vai pro fim, independente de direcao —
  // convencao comum em tabelas de UI ("sem dado" no rodape).
  if (a == null && b == null) return 0;
  if (a == null) return 1;
  if (b == null) return -1;
  // `localeCompare` com 'pt-BR' lida com acentos e maiusculas/minusculas
  // e nao depende de ICU full (funciona no Node CI sem `--with-intl=full`).
  const cmp = a.localeCompare(b, 'pt-BR', { sensitivity: 'base' });
  return direcao === 'asc' ? cmp : -cmp;
}

function compararNumeros(a: number, b: number, direcao: DirecaoOrdenacao): number {
  const cmp = a - b;
  return direcao === 'asc' ? cmp : -cmp;
}

export default function ordenarUsinasEolicas(
  usinas: UsinaEolicaDenormalizada[],
  ordenacao: OrdenacaoUsinas,
): UsinaEolicaDenormalizada[] {
  const { coluna, direcao } = ordenacao;
  const copia = [...usinas];
  copia.sort((a, b) => {
    if (coluna === 'potencia') {
      return compararNumeros(a.potencia, b.potencia, direcao);
    }
    return compararStrings(
      a[coluna as Exclude<ColunaOrdenavelUsina, 'potencia'>],
      b[coluna as Exclude<ColunaOrdenavelUsina, 'potencia'>],
      direcao,
    );
  });
  return copia;
}
